angular.module('bribac.components.cardTestStatus', [
    'bribac.values'
])

    .directive('cardTestStatus', function (
        TEST_STATE
    ) {
        function getClass(test) {
            if (test.state === TEST_STATE.OPEN)
                return 'card-warning'
            if (test.state === TEST_STATE.EXPIRED)
                return 'card-expired'
            if (!test || test.state === TEST_STATE.INACTIVE)
                return 'card-secondary'
            if (!test.bacLimitPassed)
                return 'card-danger'
            if (test.optional
                ? (test.faceRecognition && test.faceRecognition.result === TEST_STATE.FAILED)
                : (test.sample && test.sample.faceRecognition && test.sample.faceRecognition.result === TEST_STATE.FAILED))
                return 'card-frs-failed'
            if (test.state === TEST_STATE.PASSED) {
                return 'card-success'
            }
            if (test.state === TEST_STATE.FAILED) {
                return 'card-danger'
            }
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var currentClass;

                scope.$watch(attrs.cardTestStatus, function (newVal) {
                    if (newVal) {
                        if (currentClass) element.removeClass(currentClass);
                        currentClass = getClass(newVal);
                        element.addClass(currentClass);
                    }
                }, true);
            }
        }
    });
